"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datasheetPack = exports.datasheetMapReducer = void 0;
const core_1 = require("@apitable/core");
const core_2 = require("../../../core");
const redux_1 = require("redux");
const immer_1 = require("immer");
const lodash_1 = require("lodash");
const datasheetMapReducer = (state = {}, action) => {
    if (!action.datasheetId) {
        return state;
    }
    if (action.type === core_2.ActionConstants.ADD_DATASHEET) {
        const newState = Object.assign(Object.assign({}, state), { [action.datasheetId]: action.payload });
        return newState;
    }
    const result = (0, exports.datasheetPack)(state[action.datasheetId], action);
    if (result === state[action.datasheetId]) {
        return state;
    }
    return Object.assign(Object.assign({}, state), { [action.datasheetId]: result });
};
exports.datasheetMapReducer = datasheetMapReducer;
exports.datasheetPack = (0, redux_1.combineReducers)({
    connected: (state = false, action) => {
        if (action.type === core_2.ActionConstants.DATASHEET_CONNECTED) {
            return true;
        }
        return state;
    },
    datasheet: (0, immer_1.produce)((state = null, action) => {
        if (!state) {
            return null;
        }
        switch (action.type) {
            case core_2.ActionConstants.UPDATE_DATASHEET: {
                state = Object.assign(Object.assign({}, state), action.payload);
                return state;
            }
            case core_2.ActionConstants.DATASHEET_JOT_ACTION: {
                return (0, core_1.JOTApply)(state, action, core_1.filterDatasheetOp);
            }
            case core_2.ActionConstants.UPDATE_SNAPSHOT: {
                state = Object.assign(Object.assign({}, state), { snapshot: action.payload });
                return state;
            }
            case core_2.ActionConstants.REFRESH_SNAPSHOT: {
                state.snapshot = Object.assign({}, state.snapshot);
                return state;
            }
        }
        return state;
    }),
    client: (0, redux_1.combineReducers)({
        selection: core_1.selection,
        viewDerivation(state = {}, action) {
            if (action.type === core_2.ActionConstants.SET_VIEW_DERIVATION) {
                return Object.assign(Object.assign({}, state), { [action.payload.viewId]: action.payload.viewDerivation });
            }
            if (action.type === core_2.ActionConstants.PATCH_VIEW_DERIVATION) {
                const oldState = state[action.payload.viewId];
                if (oldState) {
                    return Object.assign(Object.assign({}, state), { [action.payload.viewId]: Object.assign(Object.assign({}, oldState), action.payload.viewDerivation) });
                }
                return state;
            }
            if (action.type === core_2.ActionConstants.DELETE_VIEW_DERIVATION) {
                return (0, lodash_1.omit)(state, [action.payload.viewId]);
            }
            return state;
        },
    })
});
